export default __webpack_public_path__ + "static/media/flag-northern-marianas-islands.7d5f9373.svg";